'use client'

import type { ReactNode } from 'react'

import { CardApyTextMessage } from '../CardNetApyParts'

export interface CardMessageProps {
  message: string
  children?: ReactNode
  'data-testid'?: string
}

const CardMessage = ({ message, children, 'data-testid': testId }: CardMessageProps) => {
  return (
    <CardApyTextMessage data-testid={testId}>
      {message}
      {children}
    </CardApyTextMessage>
  )
}

export default CardMessage
